function includeIf<T>(condition: boolean, item: T): T[] {
  if (condition) {
    return [item];
  }
  return [];
}

export default includeIf;
